import React from 'react';
import { useDispatch } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { getDownloadFileUrl } from '@/src/components/project/Library/api/download';

const Download = ({ itemIds }) => {
  const dispatch = useDispatch();

  const handleDownload = () => {
    dispatch({ type: 'RESET_SELECTED_ITEMS' });
  };

  return (
    <a
      href={`${getDownloadFileUrl(itemIds)}`}
      target={'_blank'}
      data-tooltip-id={`actionItem_${itemIds.toString()}_singleDownload`}
      rel="noreferrer"
      onClick={handleDownload}
    >
      <i className="material-icons">arrow_downward</i>
      <Tooltip id={`actionItem_${itemIds.toString()}_singleDownload`} place="bottom" effect="solid">
        Download
      </Tooltip>
    </a>
  );
};

export default Download;
